import { FC } from 'react';
import classnames from 'classnames';
import './MultiItemWrapper.scss';

interface MultiItemWrapperProps {
  children?: JSX.Element | string | number;
  className?: string;
  padding?: boolean;
  overflowHidden?: boolean;
  white?: boolean;
  items: string[] | string[][];
}

export const MultiItemWrapper: FC<MultiItemWrapperProps> = ({
  items,
  className = '',
  padding = true,
  overflowHidden,
  white = false,
}) => (
  <div
    className={classnames(
      'multi-item-wrapper',
      {
        'multi-item-wrapper_padding': padding,
        'multi-item-wrapper_overflow-hidden': overflowHidden,
        'creative-tour-detail__gray-item': !white,
      },
      className
    )}
  >
    {items.map((item, rowIndex) => (
      <div key={`multi-item-row-${rowIndex}`} className="multi-item-row">
        {Array.isArray(item)
          ? item.map((i, columnIndex) => (
              <div
                key={`multi-item-column-${rowIndex}-${columnIndex}`}
                className={classnames('multi-item-column', {
                  'multi-item-column_header': item.length === 1,
                })}
              >
                {i ?? ''}
              </div>
            ))
          : item ?? ''}
      </div>
    ))}
  </div>
);
